import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebhookEndpointDetailFragment = { __typename?: 'WebhookEndpoint', id: string, name?: string | null, environmentId: string, types?: Array<string | null> | null, url: string, headers: unknown, payloadMapping?: unknown | null, status: Types.WebhookStatus, created: string, updated: string, cardTemplateId?: string | null, actionFlowConfigId?: string | null, cardTemplateDefinition?: unknown | null, webhookCredentialId?: string | null, secret: string, requestMethod: Types.WebhookRequestMethod, batchInterval?: number | null, environment?: { __typename?: 'Environment', organisationId: string } | null };

export type WebhookEndpointListQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  cardTemplateId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  actionFlowConfigId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderBy?: Array<Types.WebhookEndpointsOrderBy> | Types.WebhookEndpointsOrderBy;
}>;


export type WebhookEndpointListQuery = { __typename?: 'Query', webhookEndpoints?: { __typename?: 'WebhookEndpointsConnection', totalCount: number, nodes: Array<{ __typename?: 'WebhookEndpoint', id: string, name?: string | null, environmentId: string, types?: Array<string | null> | null, url: string, headers: unknown, payloadMapping?: unknown | null, status: Types.WebhookStatus, created: string, updated: string, cardTemplateId?: string | null, actionFlowConfigId?: string | null, cardTemplateDefinition?: unknown | null, webhookCredentialId?: string | null, secret: string, requestMethod: Types.WebhookRequestMethod, batchInterval?: number | null, environment?: { __typename?: 'Environment', organisationId: string } | null }> } | null };

export type GetWebhookEndpointQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type GetWebhookEndpointQuery = { __typename?: 'Query', webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, environmentId: string, types?: Array<string | null> | null, url: string, headers: unknown, payloadMapping?: unknown | null, status: Types.WebhookStatus, created: string, updated: string, cardTemplateId?: string | null, actionFlowConfigId?: string | null, cardTemplateDefinition?: unknown | null, webhookCredentialId?: string | null, secret: string, requestMethod: Types.WebhookRequestMethod, batchInterval?: number | null, environment?: { __typename?: 'Environment', organisationId: string } | null } | null };

export type AddWebhookEndpointMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  types?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  url: Types.Scalars['String']['input'];
  requestMethod: Types.WebhookRequestMethod;
  cardTemplateId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  actionFlowConfigId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  headers?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  status?: Types.InputMaybe<Types.WebhookStatus>;
  payloadMapping?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  webhookCredentialId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  name: Types.Scalars['String']['input'];
}>;


export type AddWebhookEndpointMutation = { __typename?: 'Mutation', createWebhookEndpoint?: { __typename?: 'CreateWebhookEndpointPayload', webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, environmentId: string, types?: Array<string | null> | null, url: string, headers: unknown, payloadMapping?: unknown | null, status: Types.WebhookStatus, created: string, updated: string, cardTemplateId?: string | null, actionFlowConfigId?: string | null, cardTemplateDefinition?: unknown | null, webhookCredentialId?: string | null, secret: string, requestMethod: Types.WebhookRequestMethod, batchInterval?: number | null, environment?: { __typename?: 'Environment', organisationId: string } | null } | null } | null };

export type UpdateWebhookEndpointMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  types?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  requestMethod?: Types.InputMaybe<Types.WebhookRequestMethod>;
  headers?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  status?: Types.InputMaybe<Types.WebhookStatus>;
  payloadMapping?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  webhookCredentialId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  batchInterval?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateWebhookEndpointMutation = { __typename?: 'Mutation', updateWebhookEndpoint?: { __typename?: 'UpdateWebhookEndpointPayload', webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, environmentId: string, types?: Array<string | null> | null, url: string, headers: unknown, payloadMapping?: unknown | null, status: Types.WebhookStatus, created: string, updated: string, cardTemplateId?: string | null, actionFlowConfigId?: string | null, cardTemplateDefinition?: unknown | null, webhookCredentialId?: string | null, secret: string, requestMethod: Types.WebhookRequestMethod, batchInterval?: number | null, environment?: { __typename?: 'Environment', organisationId: string } | null } | null } | null };

export type DeleteWebhookEndpointMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteWebhookEndpointMutation = { __typename?: 'Mutation', deleteWebhookEndpoint?: { __typename?: 'DeleteWebhookEndpointPayload', webhookEndpoint?: { __typename?: 'WebhookEndpoint', id: string, name?: string | null, environmentId: string, types?: Array<string | null> | null, url: string, headers: unknown, payloadMapping?: unknown | null, status: Types.WebhookStatus, created: string, updated: string, cardTemplateId?: string | null, actionFlowConfigId?: string | null, cardTemplateDefinition?: unknown | null, webhookCredentialId?: string | null, secret: string, requestMethod: Types.WebhookRequestMethod, batchInterval?: number | null, environment?: { __typename?: 'Environment', organisationId: string } | null } | null } | null };

export type TestWebhookEndpointMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  webhookEndpointId: Types.Scalars['String']['input'];
}>;


export type TestWebhookEndpointMutation = { __typename?: 'Mutation', webhookEndpointTestMutation?: boolean | null };

export type GetWebhookLogsQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  webhookEndpointId: Types.Scalars['String']['input'];
}>;


export type GetWebhookLogsQuery = { __typename?: 'Query', getWebhookLogs?: { __typename?: 'WebhookLogsConnection', nodes: Array<{ __typename?: 'WebhookLog', id: string, payload?: unknown | null, context?: unknown | null, responseCode?: number | null, responseAt?: string | null, responseBody?: string | null, sentAt: string, webhookEndpointId: string }> } | null };

export const WebhookEndpointDetailFragmentDoc = gql`
    fragment WebhookEndpointDetail on WebhookEndpoint {
  id
  name
  environmentId
  types
  url
  headers
  payloadMapping
  status
  created
  updated
  cardTemplateId
  actionFlowConfigId
  cardTemplateDefinition
  webhookCredentialId
  secret
  requestMethod
  batchInterval
  environment {
    organisationId
  }
}
    `;
export const WebhookEndpointListDocument = gql`
    query WebhookEndpointList($environmentId: String!, $cardTemplateId: String, $actionFlowConfigId: String, $orderBy: [WebhookEndpointsOrderBy!]! = [ID_DESC]) {
  webhookEndpoints(
    orderBy: $orderBy
    condition: {environmentId: $environmentId, cardTemplateId: $cardTemplateId, actionFlowConfigId: $actionFlowConfigId}
  ) {
    nodes {
      ...WebhookEndpointDetail
    }
    totalCount
  }
}
    ${WebhookEndpointDetailFragmentDoc}`;

/**
 * __useWebhookEndpointListQuery__
 *
 * To run a query within a React component, call `useWebhookEndpointListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookEndpointListQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      cardTemplateId: // value for 'cardTemplateId'
 *      actionFlowConfigId: // value for 'actionFlowConfigId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useWebhookEndpointListQuery(baseOptions: Apollo.QueryHookOptions<WebhookEndpointListQuery, WebhookEndpointListQueryVariables> & ({ variables: WebhookEndpointListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookEndpointListQuery, WebhookEndpointListQueryVariables>(WebhookEndpointListDocument, options);
      }
export function useWebhookEndpointListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebhookEndpointListQuery, WebhookEndpointListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookEndpointListQuery, WebhookEndpointListQueryVariables>(WebhookEndpointListDocument, options);
        }
export function useWebhookEndpointListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebhookEndpointListQuery, WebhookEndpointListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebhookEndpointListQuery, WebhookEndpointListQueryVariables>(WebhookEndpointListDocument, options);
        }
export type WebhookEndpointListQueryHookResult = ReturnType<typeof useWebhookEndpointListQuery>;
export type WebhookEndpointListLazyQueryHookResult = ReturnType<typeof useWebhookEndpointListLazyQuery>;
export type WebhookEndpointListSuspenseQueryHookResult = ReturnType<typeof useWebhookEndpointListSuspenseQuery>;
export type WebhookEndpointListQueryResult = Apollo.QueryResult<WebhookEndpointListQuery, WebhookEndpointListQueryVariables>;
export const GetWebhookEndpointDocument = gql`
    query GetWebhookEndpoint($id: String!, $environmentId: String!) {
  webhookEndpoint(id: $id, environmentId: $environmentId) {
    ...WebhookEndpointDetail
  }
}
    ${WebhookEndpointDetailFragmentDoc}`;

/**
 * __useGetWebhookEndpointQuery__
 *
 * To run a query within a React component, call `useGetWebhookEndpointQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookEndpointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookEndpointQuery({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetWebhookEndpointQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables> & ({ variables: GetWebhookEndpointQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>(GetWebhookEndpointDocument, options);
      }
export function useGetWebhookEndpointLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>(GetWebhookEndpointDocument, options);
        }
export function useGetWebhookEndpointSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>(GetWebhookEndpointDocument, options);
        }
export type GetWebhookEndpointQueryHookResult = ReturnType<typeof useGetWebhookEndpointQuery>;
export type GetWebhookEndpointLazyQueryHookResult = ReturnType<typeof useGetWebhookEndpointLazyQuery>;
export type GetWebhookEndpointSuspenseQueryHookResult = ReturnType<typeof useGetWebhookEndpointSuspenseQuery>;
export type GetWebhookEndpointQueryResult = Apollo.QueryResult<GetWebhookEndpointQuery, GetWebhookEndpointQueryVariables>;
export const AddWebhookEndpointDocument = gql`
    mutation AddWebhookEndpoint($environmentId: String!, $types: [String], $url: String!, $requestMethod: WebhookRequestMethod!, $cardTemplateId: String, $actionFlowConfigId: String, $headers: JSON, $status: WebhookStatus, $payloadMapping: JSON, $webhookCredentialId: String, $name: String!) {
  createWebhookEndpoint(
    input: {webhookEndpoint: {environmentId: $environmentId, types: $types, url: $url, cardTemplateId: $cardTemplateId, actionFlowConfigId: $actionFlowConfigId, headers: $headers, status: $status, payloadMapping: $payloadMapping, webhookCredentialId: $webhookCredentialId, requestMethod: $requestMethod, name: $name}}
  ) {
    webhookEndpoint {
      ...WebhookEndpointDetail
    }
  }
}
    ${WebhookEndpointDetailFragmentDoc}`;

/**
 * __useAddWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useAddWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWebhookEndpointMutation, { data, loading, error }] = useAddWebhookEndpointMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      types: // value for 'types'
 *      url: // value for 'url'
 *      requestMethod: // value for 'requestMethod'
 *      cardTemplateId: // value for 'cardTemplateId'
 *      actionFlowConfigId: // value for 'actionFlowConfigId'
 *      headers: // value for 'headers'
 *      status: // value for 'status'
 *      payloadMapping: // value for 'payloadMapping'
 *      webhookCredentialId: // value for 'webhookCredentialId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<AddWebhookEndpointMutation, AddWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWebhookEndpointMutation, AddWebhookEndpointMutationVariables>(AddWebhookEndpointDocument, options);
      }
export type AddWebhookEndpointMutationHookResult = ReturnType<typeof useAddWebhookEndpointMutation>;
export type AddWebhookEndpointMutationResult = Apollo.MutationResult<AddWebhookEndpointMutation>;
export type AddWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<AddWebhookEndpointMutation, AddWebhookEndpointMutationVariables>;
export const UpdateWebhookEndpointDocument = gql`
    mutation UpdateWebhookEndpoint($id: String!, $environmentId: String!, $types: [String], $requestMethod: WebhookRequestMethod, $headers: JSON, $status: WebhookStatus, $payloadMapping: JSON, $webhookCredentialId: String, $batchInterval: Int, $name: String) {
  updateWebhookEndpoint(
    input: {id: $id, environmentId: $environmentId, patch: {status: $status, headers: $headers, payloadMapping: $payloadMapping, webhookCredentialId: $webhookCredentialId, requestMethod: $requestMethod, batchInterval: $batchInterval, types: $types, name: $name}}
  ) {
    webhookEndpoint {
      ...WebhookEndpointDetail
    }
  }
}
    ${WebhookEndpointDetailFragmentDoc}`;

/**
 * __useUpdateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookEndpointMutation, { data, loading, error }] = useUpdateWebhookEndpointMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *      types: // value for 'types'
 *      requestMethod: // value for 'requestMethod'
 *      headers: // value for 'headers'
 *      status: // value for 'status'
 *      payloadMapping: // value for 'payloadMapping'
 *      webhookCredentialId: // value for 'webhookCredentialId'
 *      batchInterval: // value for 'batchInterval'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>(UpdateWebhookEndpointDocument, options);
      }
export type UpdateWebhookEndpointMutationHookResult = ReturnType<typeof useUpdateWebhookEndpointMutation>;
export type UpdateWebhookEndpointMutationResult = Apollo.MutationResult<UpdateWebhookEndpointMutation>;
export type UpdateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>;
export const DeleteWebhookEndpointDocument = gql`
    mutation DeleteWebhookEndpoint($id: String!, $environmentId: String!) {
  deleteWebhookEndpoint(input: {id: $id, environmentId: $environmentId}) {
    webhookEndpoint {
      ...WebhookEndpointDetail
    }
  }
}
    ${WebhookEndpointDetailFragmentDoc}`;

/**
 * __useDeleteWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookEndpointMutation, { data, loading, error }] = useDeleteWebhookEndpointMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>(DeleteWebhookEndpointDocument, options);
      }
export type DeleteWebhookEndpointMutationHookResult = ReturnType<typeof useDeleteWebhookEndpointMutation>;
export type DeleteWebhookEndpointMutationResult = Apollo.MutationResult<DeleteWebhookEndpointMutation>;
export type DeleteWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>;
export const TestWebhookEndpointDocument = gql`
    mutation TestWebhookEndpoint($environmentId: String!, $webhookEndpointId: String!) {
  webhookEndpointTestMutation(
    environmentId: $environmentId
    endpointId: $webhookEndpointId
  )
}
    `;

/**
 * __useTestWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useTestWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testWebhookEndpointMutation, { data, loading, error }] = useTestWebhookEndpointMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useTestWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<TestWebhookEndpointMutation, TestWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestWebhookEndpointMutation, TestWebhookEndpointMutationVariables>(TestWebhookEndpointDocument, options);
      }
export type TestWebhookEndpointMutationHookResult = ReturnType<typeof useTestWebhookEndpointMutation>;
export type TestWebhookEndpointMutationResult = Apollo.MutationResult<TestWebhookEndpointMutation>;
export type TestWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<TestWebhookEndpointMutation, TestWebhookEndpointMutationVariables>;
export const GetWebhookLogsDocument = gql`
    query GetWebhookLogs($environmentId: String!, $webhookEndpointId: String!) {
  getWebhookLogs(
    environmentId: $environmentId
    webhookEndpointId: $webhookEndpointId
  ) {
    nodes {
      id
      payload
      context
      responseCode
      responseAt
      responseBody
      sentAt
      webhookEndpointId
    }
  }
}
    `;

/**
 * __useGetWebhookLogsQuery__
 *
 * To run a query within a React component, call `useGetWebhookLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookLogsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useGetWebhookLogsQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookLogsQuery, GetWebhookLogsQueryVariables> & ({ variables: GetWebhookLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookLogsQuery, GetWebhookLogsQueryVariables>(GetWebhookLogsDocument, options);
      }
export function useGetWebhookLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookLogsQuery, GetWebhookLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookLogsQuery, GetWebhookLogsQueryVariables>(GetWebhookLogsDocument, options);
        }
export function useGetWebhookLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebhookLogsQuery, GetWebhookLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebhookLogsQuery, GetWebhookLogsQueryVariables>(GetWebhookLogsDocument, options);
        }
export type GetWebhookLogsQueryHookResult = ReturnType<typeof useGetWebhookLogsQuery>;
export type GetWebhookLogsLazyQueryHookResult = ReturnType<typeof useGetWebhookLogsLazyQuery>;
export type GetWebhookLogsSuspenseQueryHookResult = ReturnType<typeof useGetWebhookLogsSuspenseQuery>;
export type GetWebhookLogsQueryResult = Apollo.QueryResult<GetWebhookLogsQuery, GetWebhookLogsQueryVariables>;